import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";
import styles from "../../styles";
import { PageReference } from "../PageReference";

const SubSectionTitle = ({
    t,
    title,
    number,
    anchorId,
}) => {
    return (
        <View style={styles.sectionBlock} wrap={false} minPresenceAhead={160}>
            <PageReference id={anchorId} />
            <Text style={styles.subSectionTitle}>
                {number ? `${number} ${t(title)}` : t(title)}
            </Text>
        </View>
    );
};

export default withNamespaces()(SubSectionTitle);
